export default __webpack_public_path__ + "static/media/Headband of the Kozak Slayer.0f6f77b2.jpg";